import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const COPY = {
  en: { title: "Where would you like to serve?", hint: "Your results are a guide, not an assignment. Pick the team you'd personally love to join, or skip this.", ph: "Choose a team (optional)", none: "No preference", saved: "Thanks! Your preference was saved." },
  es: { title: "¿Dónde te gustaría servir?", hint: "Tus resultados son una guía, no una asignación. Elige el equipo al que te encantaría unirte, u omite este paso.", ph: "Elige un equipo (opcional)", none: "Sin preferencia", saved: "¡Gracias! Guardamos tu preferencia." },
};

export const PreferredMinistry = ({ vid, options, initial, lang }) => {
  const c = COPY[lang] || COPY.en;
  const [value, setValue] = useState(initial || "none");
  const [busy, setBusy] = useState(false);
  const save = async (val) => {
    setValue(val);
    setBusy(true);
    try {
      await api.post(`/public/results/${vid}/preferred`, { team_id: val === "none" ? null : val });
      toast.success(c.saved);
    } catch {
      toast.error("Could not save");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="card-soft p-8" data-testid="preferred-ministry-section">
      <p className="font-display text-navy text-xl font-semibold">{c.title}</p>
      <p className="text-muted-ink mt-2 max-w-2xl">{c.hint}</p>
      <div className="mt-5 max-w-sm">
        <Select value={value} onValueChange={save} disabled={busy}>
          <SelectTrigger className="h-12" data-testid="preferred-ministry-select"><SelectValue placeholder={c.ph} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none" data-testid="preferred-option-none">{c.none}</SelectItem>
            {options.map((o) => <SelectItem key={o.team_id} value={o.team_id} data-testid={`preferred-option-${o.team_id}`}>{o.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </section>
  );
};
